// extracted by mini-css-extract-plugin
export var logo = "_ix-2";
export var logoWrapper = "_ix-1";
export var strip = "_ix-0";